// extracted by mini-css-extract-plugin
export default {"app":"App_app__hICAv","switchers":"App_switchers__Mrdan"};